const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

/**
 * AI Prompt Command API URL'leri
 */
export const AIPromptCommandUrl = {
    /**
     * Yeni AI Prompt oluşturma
     * POST /api/v1/aiprompts
     */
    CreateAIPrompt: Backofficebff + '/v1/aiprompts',

    /**
     * AI Prompt güncelleme
     * PUT /api/v1/aiprompts/{id}
     */
    UpdateAIPrompt: Backofficebff + '/v1/aiprompts',

    /**
     * AI Prompt silme (Soft delete)
     * DELETE /api/v1/aiprompts/{id}
     */
    DeleteAIPrompt: Backofficebff + '/v1/aiprompts',
};

